import { doc, runTransaction } from "firebase/firestore";
import { db } from "../../firebase";

// Mirrors the formData mutations that `onrigchecksubmit` used to perform on
// `Rigchecks/.../{agency} Rigchecks/{checkId}`. Moving this client-side lets
// us look up nested options by `option.key` (unique) instead of `option.value`
// (which collides on duplicate-value templates).
const matchSubmissionsById = (processedData) => {
  const out = new Map();
  (processedData || []).forEach((item) => {
    if (item && item.id) out.set(item.id, item);
  });
  return out;
};

const applyNestedOptionDates = (field, submitted) => {
  if (!Array.isArray(field.options)) return false;
  const map = submitted && submitted.expiration_dates;
  if (!map) return false;

  let touched = false;
  field.options.forEach((option) => {
    if (!option || !option.hasExpiration) return;
    const date = map[option.key];
    if (date) {
      option.expiration_date = date;
      touched = true;
    }
  });
  return touched;
};

const applyPerUnitDates = (field, submitted) => {
  const map = submitted && submitted.expiration_dates;
  if (!map) return false;
  const unitKeys = Object.keys(map)
    .filter((k) => k.startsWith("unit_"))
    .sort(
      (a, b) =>
        parseInt(a.replace("unit_", ""), 10) -
        parseInt(b.replace("unit_", ""), 10)
    );
  const formatted = unitKeys.map((k) => map[k]).filter((v) => v);
  if (formatted.length === 0) return false;
  field.unitExpirationDates = formatted;
  return true;
};

export async function applyAnswerPlaceholders({
  agency,
  checkId,
  processedData,
}) {
  if (!agency || !checkId || !Array.isArray(processedData)) return;

  const rigcheckRef = doc(
    db,
    "Rigchecks",
    "VgTv80ik2BtavT0A5owc",
    `${agency} Rigchecks`,
    checkId
  );

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(rigcheckRef);
    if (!snap.exists()) return;
    const data = snap.data();
    if (!data || !data.form) return;

    let formData;
    try {
      formData = JSON.parse(data.form);
    } catch (e) {
      return;
    }
    if (!Array.isArray(formData)) return;

    const byId = matchSubmissionsById(processedData);
    let updated = false;

    formData.forEach((field) => {
      if (!field) return;
      const submitted = byId.get(field.id);
      if (!submitted) return;

      const isCheckboxes = field.element === "Checkboxes";
      const isSealedBroken = field.key === "SealedBrokenComponent";
      const isPassFail = field.key === "PassFailComponent";
      const isExpirationField =
        field.element === "CustomElement" &&
        field.key === "ExpirationDateComponent";

      if (isCheckboxes || isSealedBroken) {
        if (applyNestedOptionDates(field, submitted)) updated = true;
      }

      if (isPassFail) {
        if (field.requiresExpirationPerUnit) {
          if (applyPerUnitDates(field, submitted)) updated = true;
        }
        if (submitted.expiration_date) {
          field.expiration_date = submitted.expiration_date;
          updated = true;
        }
      }

      if (isSealedBroken && submitted.expiration_date) {
        field.expiration_date = submitted.expiration_date;
        updated = true;
      }

      if (isExpirationField && submitted.value) {
        field.expiration_date = submitted.value;
        updated = true;
      }
    });

    if (updated) {
      tx.update(rigcheckRef, { form: JSON.stringify(formData) });
    }
  });
}
